import React from "react";
import Hero from "../../components/Page7Components/Hero";
import TabSection from "../../components/Page7Components/TabSection";

const Page7 = () => {
  return (
    <div>
      <Hero></Hero>
      <TabSection></TabSection>
    </div>
  );
};

export default Page7;
